import { Card, CardBody, Tab, Tabs } from "@nextui-org/react";
import Form from "./NewFrame";
import EditFrame from "./EditFrame";
import RemoveFrame from "./RemoveFrame";

const Frame = () => {
    return (
        <>
            <div className="w-full flex flex-col">
                <Tabs aria-label="Options" className="border-b pb-3">
                    <Tab key="new" title="جدید">
                        <Card style={{ boxShadow: 'none' }}>
                            <CardBody>
                                <Form />
                            </CardBody>
                        </Card>
                    </Tab>
                    <Tab key="edit" title="ویرایش">
                        <Card style={{ boxShadow: 'none' }}>
                            <CardBody>
                                <EditFrame />
                            </CardBody>
                        </Card>
                    </Tab>
                    <Tab key="delete" title="حذف">
                        <Card style={{ boxShadow: 'none' }}>
                            <CardBody>
                                <RemoveFrame />
                            </CardBody>
                        </Card>
                    </Tab>
                </Tabs>
            </div>
        </>
    );
};

export default Frame;